import { useState } from 'react';

const faqItems = [
  {
    q: '777影院需要注册会员才能观看吗？',
    a: '不需要。777影院坚持无门槛观影理念，打开网站即可免费在线观看所有电影、电视剧、综艺内容，无需注册、无需登录、无需付费，真正做到即点即看。',
  },
  {
    q: '777影院的画质怎么样？支持4K超清吗？',
    a: '777影院提供多档清晰度选择，最高支持4K超清画质。平台采用智能CDN加速与多线路切换技术，在网络良好的情况下可流畅播放超清内容，确保观影不卡顿。',
  },
  {
    q: '手机和平板能看吗？有没有APP？',
    a: '777影院已全面适配手机、平板和电脑端，网页版即可在移动端获得良好观影体验。同时提供APP客户端下载，支持离线缓存功能，通勤路上也能畅快追剧。',
  },
  {
    q: '剧集更新速度怎么样？能第一时间看到最新内容吗？',
    a: '777影院拥有专业的内容更新团队，热播剧集通常在播出后2小时内同步上线。院线电影也会在流媒体上线后第一时间更新，确保你能以最快速度追到最新内容。',
  },
  {
    q: '777影院真的完全没有广告吗？',
    a: '是的。777影院的核心理念就是免费无广告观影。播放页面前、播放过程中及播放结束后均无任何形式的广告插入，提供纯净的观影环境，让你沉浸式享受每一部作品。',
  },
  {
    q: '遇到播放卡顿或资源失效怎么办？',
    a: '平台为每部影片提供多条播放线路，如遇卡顿或某条线路失效，可点击切换按钮更换其他线路。同时建议检查网络环境或降低清晰度以获得更流畅体验。如有其他问题可通过联系我们反馈。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">常见问题</h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-800/30 border border-background-700/20 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 pr-4">{item.q}</h3>
                <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all ${
                  openIndex === i ? 'bg-accent-500/20 rotate-45' : 'bg-background-700/50'
                }`}>
                  <i className="ri-add-line text-accent-400 text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}